export default "__VITE_ASSET__BVnCtFH6__"